import React, { useEffect, useState } from 'react';
import useSize from '../../../../../hooks/useSize';
import { KTSVG, toAbsoluteUrl } from '../../../../../../_metronic/helpers';

export function CardPlant({
    data, 
    plantSelected,
    setShowCreateAppModal, 
    setMyPlant,
    mapRef
} : any) {

    function corrigirCoordenada(coordenadaString: string) {
        if (coordenadaString.includes(',')) {
            return coordenadaString.replace(',', '.');
        } else {
            return coordenadaString;
        }
    }
    
    const {width} = useSize();
    const [myPosition, setMyPosition] = useState({
        lat: null as number | null,
        lng:  null as number | null
    });

    useEffect(() => {
        setMyPosition({
            lat: data.plantLat && data.plantLat !== null && data.plantLat !== undefined
                ? (Number.isNaN(Number(corrigirCoordenada(data.plantLat.toString()))) ? -15.7939 : Number(corrigirCoordenada(data.plantLat.toString())))
                : -15.7939,
            lng: data.plantLon && data.plantLon !== null && data.plantLon !== undefined
                ? (Number.isNaN(Number(corrigirCoordenada(data.plantLon.toString()))) ? -47.8828 : Number(corrigirCoordenada(data.plantLon.toString())))
                : -47.8828
        })
    }, [plantSelected])

  return (
    <div 
        className={`card bg-light border border-solid mt-2 ${ plantSelected === data.id ? "border-primary border-4" : "border-gray-300 border-hover border-2"}`} 
        style={{width: '280px', cursor: 'pointer'}}
       
        onClick={() => {
            setMyPlant(data.id)
            mapRef.current?.flyTo({
                center: [myPosition.lng || -47.8828, myPosition.lat || -15.7939],
                zoom: data.plantLat 
                    && data.plantLat !== "None" 
                    && data.plantLon 
                    && data.plantLon !== "None" ? 6 : 4,
                essential: true,
            })
        }}
    >
        <div className={`card-header bg-${
                    data && data.status !== null
                    ? data.status === 0
                        ? "success"
                        : data.status === 1
                        ? "danger"
                        : data.status === 2
                        ? "warning"
                        : data.status === 7 || data.status === 3
                        ? "info"
                        : "primary"
                    : "primary"
                } p-3`} style={{display: 'flex', alignItems: 'center', flexWrap: 'nowrap', justifyContent: 'start', gap: '1.5rem', minHeight: '50px'}}>
            <div className="symbol symbol-30px symbol-fixed position-relative p-0 m-0">
                <img src={toAbsoluteUrl('/media/imgs/plant2.png')} alt="Metornic" />
                <div
                className={`position-absolute translate-middle bottom-0 start-100 mb-0 bg-${
                    data && data.status !== null
                    ? data.status === 0
                        ? "success"
                        : data.status === 1
                        ? "danger"
                        : data.status === 2
                        ? "warning"
                        : data.status === 7 || data.status === 3
                        ? "info"
                        : "secondary"
                    : "secondary"
                } rounded-circle border border-4 border-white h-15px w-15px`}
                ></div>
            </div>

            <h3 className="card-title d-flex align-items-start flex-column p-0 m-0">
                <span className={`card-label fw-bold fs-${width < 1200 ? "5" : "6"} mb-1 text-truncate`} style={{ maxWidth: "200px" }}>
                    {data && data.name ? data.name : ""}
                </span>
                <span className="text-light fw-semibold fs-9 text-truncate" style={{ maxWidth: "200px" }}>
                    {data && data.address ? data.address : ""}
                </span>
            </h3>
        </div>

        <div className='card-body p-3'>
            <div style={{display: 'flex', gap: '1.5rem', flexWrap: 'wrap'}}>
                <div style={{display: 'flex', alignItems: "center", gap: '0.5rem'}}>
                    <div className='symbol symbol-30px bg-light' >
                        {
                        data && data.mark && data.mark.link_imagem ? 
                        (
                            <img
                                src={toAbsoluteUrl(`${data.mark.link_imagem}`)}
                                className=''
                                alt=''
                            />
                        ) 
                        :
                        (
                            <KTSVG path='/media/icons/duotune/coding/cod009.svg' className='svg-icon-2x svg-icon-dark'/>
                        )
                        }
                    </div>
                    <a 
                        href='#' 
                        title={`${data.mark && data.mark.name
                            ? data.mark.name 
                            : ""}`}
                        className='text-muted fw-semibold text-hover-primary d-block fs-7'
                        style={{
                            width: "90px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                          }}
                    >
                        {
                            data.mark && data.mark.name
                            ? data.mark.name 
                            : ""
                        }
                    </a>
                </div>
                
                <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                    <div className='symbol symbol-30px bg-light' >
                        <KTSVG path='/media/icons/duotune/coding/cod001.svg' className='svg-icon-2x svg-icon-dark'/>
                    </div>
                    <a href='#' className='text-muted fw-semibold text-hover-primary d-block fs-7'>
                        {
                            data && data.capacity
                            ? data.capacity + " KWp"
                            : 
                            "0 KWp"
                        }
                    </a>
                </div>
            </div>
        </div>

        <div className='card-footer p-3' style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <a 
                href='#' 
                className='text-primary fw-bold text-hover-secondary fs-7' 
                onClick={() => {
                    setMyPlant(data.id)
                    setShowCreateAppModal(true)
                }}
            >
                Ver detalhes
                <KTSVG path='/media/icons/duotune/arrows/arr001.svg' className='svg-icon-2x text-primary fw-bold text-hover-secondary'/>

            </a>

            <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                    {/* <div className='symbol symbol-30px bg-light' >
                        <KTSVG path='/media/icons/duotune/coding/cod009.svg' className='svg-icon-2x svg-icon-dark'/>
                    </div> */}
                    <span className={`bg-primary badge badge-white fw-bolder fs-7 px-2 py-1 ms-2`}>
                        {
                        data.plano
                        ? data.plano 
                        : 
                        ""
                        }
                    </span>
                </div>
        </div>
    </div>
  );
}